var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isVisible)?_c('div',{staticClass:"wrapper"},[_c('AppButtonCancel',{on:{"click":_vm.discard}},[_vm._v("保存せず終了")]),_c('AppButtonOk',{attrs:{"loading":_vm.loading,"color":"primary"},on:{"click":_vm.save}},[_vm._v("\n      保存\n    ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }